







import Vue from 'vue'
import UiTag from '@/components/Ui/Tag/Tag.vue'
import Poll from '@/models/polls/Poll'

export default Vue.extend({
  props: {
    status: String,
    poll: Object as () => Poll
  },
  components: {
    UiTag
  }
})
